module.exports = __webpack_public_path__ + "static/media/Chloroform_Room_Setup.5ed88ca5.mp3";